import React from 'react';
import Icon from '../../../../muiComponents/Icon';
import { supplierTaxCalculationTypesIcons } from '../../../../utils/taxes/taxesListUtils';
import Tooltip from '../../../../muiComponents/Tooltip';
import useTranslate from '../../../../customHooks/useTranslate';

interface ISupplierTaxCalculationTypeIconProps {
    entityKey: string;
    text: string;
}

const SupplierTaxCalculationTypeIcon = ({
    entityKey,
    text,
}: ISupplierTaxCalculationTypeIconProps) => {
    const translate = useTranslate();
    const supplierTaxCalculationTypeIcon =
        supplierTaxCalculationTypesIcons[
            entityKey as keyof typeof supplierTaxCalculationTypesIcons
        ];
    return (
        <Tooltip title={`${translate('calculation_type')}: ${text || ''}`}>
            <span className='flex gap-5 flex-align-center'>
                <Icon iconName={supplierTaxCalculationTypeIcon} />
            </span>
        </Tooltip>
    );
};

export default SupplierTaxCalculationTypeIcon;
